
import { useReducer } from "react";
import { FormState, FormAction, FormData } from "./types";
import { BusinessCategoryString } from "@/types/business";

const initialFormData: FormData = {
  name: "",
  description: "",
  address: "",
  city: "",
  state: "",
  county: "",
  category: "" as BusinessCategoryString,
  tags: "",
  website: "",
  phone: "",
  email: "",
  mediaFiles: [],
  facebook: "",
  instagram: "",
  tiktok: "",
  region: "",
  postcode: "",
  what3words: "",
  approved: false,
};

const initialState: FormState = {
  formData: initialFormData,
  formErrors: {},
  isSubmitting: false,
};

const formReducer = (state: FormState, action: FormAction): FormState => {
  switch (action.type) {
    case "SET_FORM_DATA":
      return {
        ...state,
        formData: { ...state.formData, ...action.payload },
      };
    case "SET_ERROR":
      return {
        ...state,
        formErrors: { ...state.formErrors, [action.field]: action.message },
      };
    case "CLEAR_ERROR":
      const newErrors = { ...state.formErrors };
      delete newErrors[action.field];
      return {
        ...state,
        formErrors: newErrors,
      };
    case "SET_SUBMITTING":
      return {
        ...state,
        isSubmitting: action.isSubmitting,
      };
    case "RESET_FORM":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const useFormState = () => {
  const [state, dispatch] = useReducer(formReducer, initialState);

  const setFormData = (data: Partial<FormData>) => {
    dispatch({ type: "SET_FORM_DATA", payload: data });
  };

  const setFormError = (field: string, message: string) => {
    dispatch({ type: "SET_ERROR", field, message });
  };

  const clearFormError = (field: string) => {
    dispatch({ type: "CLEAR_ERROR", field });
  };

  const setIsSubmitting = (isSubmitting: boolean) => {
    dispatch({ type: "SET_SUBMITTING", isSubmitting });
  };

  const resetForm = () => {
    dispatch({ type: "RESET_FORM" });
  };

  return {
    ...state,
    setFormData,
    setFormError,
    clearFormError,
    setIsSubmitting,
    resetForm,
  };
};
